<div class="yzoom-wrapper">
  <span class="yzoom-label" #yzoompop="bs-popover" [popover]="yzoomTemplate" triggers="click" [outsideClick]=true><img
  src="assets/images/icons8-collapse-24.png" class="image-fit" alt="Zoom"></span>
</div>
<ng-template #yzoomTemplate>
  <div class="zoom-input">
    <div class="min">
      <mat-form-field appearance="outline" class="fw spc-form-field yzoom-input">
        <input type="number" placeholder="min" matInput required autocomplete="off" (change)="zoomValueChange()"
          [formControl]="yzoommin">
        </mat-form-field>
      </div>
      <div class="max">
        <mat-form-field appearance="outline" class="fw spc-form-field yzoom-input">
          <input type="number" placeholder="max" matInput autocomplete="off" (change)="zoomValueChange()" required
            [formControl]="yzoommax">
          </mat-form-field>
        </div>
        @if (yzoommax?.value<yzoommin?.value) {
          <mat-hint class="error">
            <strong>Max >= Min</strong>
          </mat-hint>
        }
        <div>
          <span>
            @if (!paramDtls?.yzoom?.zoom && yzoommax?.value && yzoommin?.value &&
              yzoommax?.value>=yzoommin?.value) {
              <img src="assets/images/check.svg" alt="check" class="set-clear"
                (click)="zoomSubmit('set',yzoompop)">
            }
          </span>
          <span>
            @if (paramDtls?.yzoom?.zoom || (!yzoommax?.value && !yzoommin?.value)) {
              <img src="assets/images/clear.svg"
                alt="clear"
                class="set-clear" (click)="zoomSubmit('clear',yzoompop)">
            }
          </span>
        </div>
      </div>
    </ng-template>